import { useState } from "react";
import LazyMultiSelect from "../InputComponents/Filters/LazyMultiSelect";
import { useMsal } from "@azure/msal-react";
import { AdminApi } from "../../Api/AdminApi";

export interface UserFilters {
  names: string[];        
  projects: string[]; 
  beneficiaries: string[];
  azureIds: string[];
  emails: string[];       
}

interface UserFilterProps {
  onFiltersChange: (filters: UserFilters) => void;
}

const UserFilter: React.FC<UserFilterProps> = ({ onFiltersChange }) => {
    const { instance, accounts } = useMsal();
    const api = new AdminApi(accounts[0], instance);
    const [filtersVisible, setFiltersVisible] = useState(true);
    const [selectedNames, setSelectedNames] = useState<string[]>([]);
    const [selectedProjects, setSelectedProjects] = useState<string[]>([]);
    const [selectedBeneficiaries, setSelectedBeneficiaries] = useState<string[]>([]);
    const [selectedAzureIds, setSelectedAzureIds] = useState<string[]>([]);
    const [selectedEmails, setSelectedEmails] = useState<string[]>([]);

  
    const handleNameSelectionChange = (values: string[]) => {
      setSelectedNames(values);
      onFiltersChange({
        names: values,
        projects: selectedProjects,
        beneficiaries: selectedBeneficiaries,
        azureIds: selectedAzureIds,
        emails: selectedEmails
      });
    };

    const handleProjectSelectionChange = (values: string[]) => {
      setSelectedProjects(values);
      onFiltersChange({
        names: selectedNames,
        projects: values,
        beneficiaries: selectedBeneficiaries,
        azureIds: selectedAzureIds,
        emails: selectedEmails
      });
    };
    
    const handleAzureIdSelectionChange = (values: string[]) => {
      setSelectedAzureIds(values);
      onFiltersChange({
        names: selectedNames,
        projects: selectedProjects,
        beneficiaries: selectedBeneficiaries,
        azureIds: values,
        emails: selectedEmails
      });
    };

    const handleEmailSelectionChange = (values: string[]) => {
      setSelectedEmails(values);
      onFiltersChange({
        names: selectedNames,
        projects: selectedProjects,
        beneficiaries: selectedBeneficiaries,
        azureIds: selectedAzureIds,
        emails: values
      });
    };
  
    const injectCss = `
      .custom-form-control,
      .custom-form-select,
      .custom-form-select option {
        height: 60px !important;
        font-size: 19px !important;
        font-family: inherit !important;
      }
    `;
  
    const buttonStyle = {
      fontSize: "14px",
      fontWeight: 400,
      padding: "4px 8px",
      color: "#6c757d",
      textDecoration: "none",
      border: "none",
      background: "none"
    };
  
    return (
      <div className="mt-4 mb-4">
        <style>{injectCss}</style>
        
        <div className="d-flex justify-content-end mb-2">
          <button 
            onClick={() => setFiltersVisible(!filtersVisible)}
            className="btn btn-sm text-secondary"
            style={buttonStyle}
          >
            {filtersVisible ? "Hide filters" : "Show filters"}
          </button>
        </div>
        {filtersVisible && (
          <div className="row g-2 mb-2">
          <div className="col-md-3">
            <LazyMultiSelect
              onSelectionChange={handleProjectSelectionChange}
              placeholder="Filter by Project"
              className="w-100" 
              fetchFunction={(query, page, limit) => api.getProjectNames(query, page, limit)}
              initialValue={selectedProjects}
            />
          </div>
            <div className="col-md-3">
              <LazyMultiSelect
                onSelectionChange={handleNameSelectionChange}
                placeholder="Filter by Name"
                className="w-100" 
                fetchFunction={(query, page, limit) => api.getUserNames(query, page, limit)}
                initialValue={selectedNames}
              />
            </div>
            <div className="col-md-3">
              <LazyMultiSelect
                onSelectionChange={handleEmailSelectionChange}
                placeholder="Filter by Email"
                className="w-100" 
                fetchFunction={(query, page, limit) => api.getUserEmails(query, page, limit)}
                initialValue={selectedEmails}
              />
            </div>
            <div className="col-md-3">
              <LazyMultiSelect
                onSelectionChange={handleAzureIdSelectionChange}
                placeholder="Filter by Azure Id"
                className="w-100" 
                fetchFunction={(query, page, limit) => api.getUserAzureAdId(query, page, limit)}
                initialValue={selectedAzureIds}
              />
            </div>
          </div>
        )}
      </div>
    );
  };
  
  export default UserFilter;